import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgxExtendedPdfViewerService, pdfDefaultOptions } from 'ngx-extended-pdf-viewer';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { DocViewerManagerComponent } from '../doc-viewer-manager/doc-viewer-manager.component';

@Component({
  selector: 'dk-pdf-popup',
  standalone: true,
  imports: [CommonModule,NgxExtendedPdfViewerModule,DocViewerManagerComponent],
  templateUrl: './pdf-popup.component.html',
  styleUrls: ['./pdf-popup.component.scss'],
})
export class PdfPopupComponent implements OnInit {
  @Input() base64Src:string;
  @Input() docId:number;

  public spreadMode: 'off' | 'even' | 'odd' = 'off';
public page = 1;
public pageLabel!: string;
documentLoad= false;
  fileUrl: SafeResourceUrl;

constructor(private pdfViewerService: NgxExtendedPdfViewerService,
      public sanitizer: DomSanitizer){
  pdfDefaultOptions.assetsFolder = 'bleeding-edge'; 
}

ngOnInit(): void {
  this.base64Change();
}

base64Change(){
  let content = this.base64Src?.split('base64,').pop();
  const byteCharacters = atob(content);
  const byteNumbers = new Array(byteCharacters.length);
  for (let i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
  }
  const byteArray = new Uint8Array(byteNumbers);
  const blob = new Blob([byteArray], { type: 'application/pdf'});
  const url = URL.createObjectURL(blob);
  this.fileUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);
  this.documentLoad = true;
}


public onPageRendered(): void {
  if (!this.pdfViewerService.isRenderQueueEmpty()) {
    // try again later when the pages requested by the pdf.js core or the user have been rendered
    setTimeout(() => this.onPageRendered(), 100);
  }

  const pagesBefore = this.spreadMode === 'off' ? 2 : 2;
  const pagesAfter = this.spreadMode === 'off' ? 2 : 5;
  const startPage = Math.max(this.page - pagesBefore, 1);
  const endPage = Math.min(this.page  + pagesAfter, this.pdfViewerService.numberOfPages());

  const renderedPages = this.pdfViewerService.currentlyRenderedPages();

  for (let page = startPage; page <= endPage; page++) {
    const pageIndex = page - 1;
    if (!this.pdfViewerService.hasPageBeenRendered(pageIndex)) {
        this.pdfViewerService.addPageToRenderQueue(pageIndex);
        break; // break because you can request only one page at a time
    }
  }
}

onDocumentLoad() {
  this.documentLoad = true;
}
onFileError() {
  this.documentLoad = false;
}
}
